module.exports = __webpack_public_path__ + "img/plant_1.4b32ff16.webp";